import { types as t } from 'mobx-state-tree';

import {
  defaultOptions,
  TFNAnswerQuestion,
} from '../../../question-data-model/Question/_implementations/tfn-answer-question.store';
import { ExtraQuestionProps } from '../../components/questions/BaseQuestion';
import { ResultTestQuestionStore } from '../result-test-question.store';

export const ResultTFNQuestion = t
  .compose(ResultTestQuestionStore, TFNAnswerQuestion)
  .named('ResultTFNQuestion')
  .views((self) => ({
    get questionCount() {
      return self.correctOptions.length;
    },
    getQuestions() {
      const fistUserAnswer = self.userAnswers.find((_, index) => index === 0);
      const firstCorrectOption = self.correctOptions.find((_, index) => index === 0);
      const firstMarked = self.marked.find((_, index) => index === 0);
      const firstOption = self.options.find((_, index) => index === 0);

      const extraProps: ExtraQuestionProps = {
        no: self.no,
        correction: firstCorrectOption,
        corrections: self.correctOptions,
        markedStatus: firstMarked,
        userAnswer: fistUserAnswer,
        option: firstOption,
        userAnswerKey: defaultOptions.find((option) => fistUserAnswer === option.key)?.value,
        correctAnswerKey: defaultOptions.find((option) => firstCorrectOption?.key === option.key)
          ?.value,
      };
      return [
        {
          ...self,
          ...extraProps,
        },
      ];
    },
  }));
